console.log('iii player')
import {
  THREE,
  game,
  cameraManager,
  errorManager,
  playersManager,
  CameraStates,
  timeManager,
  gsap,
  audioManager
} from '@powerplay/core-minigames'
import {
  modelsConfig,
  gameConfig,
  cameraConfig
} from '../../../config'
import {
  AudioNames,
  BlueBoxTextType,
  DisciplinePhases,
  ModelsNames
} from '../../../types'
import { Athlete } from '..'
import { disciplinePhasesManager } from '@/app/phases/DisciplinePhasesManager'
import {
  uiState,
  tutorialState,
  gamePhaseState
} from '@/stores'

/**
 * Trieda pre hraca
 */
export class Player extends Athlete {

  /** Ci je dokoncena transformacia kamery v speed locku */
  public speedLockCameraTransformationComplete = false

  /** stara player position pred resetom */
  private oldPlayerPos: {[key in CameraStates]: THREE.Vector3 | undefined} = {
    [CameraStates.intro]: undefined,
    [CameraStates.disciplineIntro]: undefined,
    [CameraStates.discipline]: undefined,
    [CameraStates.disciplineIntroSecond]: undefined,
    [CameraStates.disciplineOutro]: undefined,
    [CameraStates.intro2]: undefined,
    [CameraStates.static]: undefined,
    [CameraStates.table]: undefined,
  }

  /**
   * Vratenie objektu atleta
   * @returns Objekt atleta
   */
  protected getObject(): THREE.Object3D {

    const meshAthleteName = modelsConfig[ModelsNames.athlete]?.mainMeshNames?.[0]
    if (!meshAthleteName) {

      throw new Error(errorManager.showBox('Mesh name for athlete was not defined'))

    }

    return game.getObject3D(meshAthleteName)

  }

  /**
   * Vytvorenie lyziara
   */
  public create(): void {

    console.log('vytvaram hraca...')

    this.uuid = playersManager.getPlayer().uuid

    super.create('Player', ModelsNames.athlete)

  }

  /**
   * Aktualizovanie kamera konfigu na zaciatku este
   * @param cameraState - Kamerovy stav
   */
  public updateCameraConfigOnStart(cameraState: CameraStates): void {

    const playerPosition = player.getPosition().clone()

    const cameraData = cameraManager.getTweenSettings()[cameraState]
    if (!cameraData) return

    const cameraDataFromState = (Array.isArray(cameraData)) ? cameraData[0] : cameraData

    // po resete chceme resetnut nastavenia na povodne
    if (this.oldPlayerPos[cameraState]) {

      cameraDataFromState.startPosition.sub(this.oldPlayerPos[cameraState] as THREE.Vector3)
      cameraDataFromState.endPosition.sub(this.oldPlayerPos[cameraState] as THREE.Vector3)

    }
    this.oldPlayerPos[cameraState] = playerPosition.clone()

    cameraDataFromState.startPosition.add(playerPosition)
    cameraDataFromState.endPosition.add(playerPosition)

  }

  /**
   * Konecna akcia pre hraca
   */
  public finishAction(): void {

    // najskor musime ukoncit moznost pohybovych animacii
    this.activeUpdatingMovementAnimations = false

    // reset kamery
    cameraManager.getMainCamera().up.set(0, 1, 0)

  }

  /**
   * changes config of camera
   * @param idealOffset - ideal shift of camera from player
   * @param idealLookAt - ideal place for camera to look at
   * @param coefSize - how fast should camera move (0-1)
   * @param changeLerp - how fast changes should be applied (0-1)
   * @param staticMovement - true, ak sa nema dat lerp na poziciu kamery
   */
  public changeCameraSettings(
    idealOffset?: THREE.Vector3,
    idealLookAt?: THREE.Vector3,
    coefSize?: number,
    changeLerp?: number,
    staticMovement?: boolean,
  ): void {

    cameraManager.changeIdeals(
      idealOffset,
      idealLookAt,
      coefSize,
      changeLerp,
      staticMovement
    )

  }

  /**
   * nastavime camera settings podla game configu
   *
   * @param lerpSize - volitelny iny lerp ako v game configu
   * @param staticMovement - true, ak pojde pozicia bez lerpu
   */
  public setGameCameraSettings(lerpSize = gameConfig.cameraConfig.changeLerp, staticMovement = false): void {

    this.changeCameraSettings(
      gameConfig.cameraConfig.idealOffset,
      gameConfig.cameraConfig.idealLookAt,
      gameConfig.cameraConfig.coefSize,
      lerpSize,
      staticMovement
    )

  }

  /**
   * Aktualizovanie hraca pred vykonanim fyziky
   * @param actualPhase - Aktualna faza
   * @param inTop3 - Ci je hrac v top 3
   */
  public updateBeforePhysics(actualPhase: DisciplinePhases, inTop3 = false): void {

    super.updateBeforePhysics(actualPhase, inTop3)

  }

  /**
   * Aktivacia speed lock-u
   */
  public activateSpeedLock(): void {

    super.activateSpeedLock()

    this.changeSpeedLockSpeed(cameraConfig.speedLock.coefCameraChange)

    tutorialState().showInstructionBox = false
    gamePhaseState().showBar = false
    uiState().blueBoxTextType = BlueBoxTextType.hidden

    const { speedLockCoefFinishLine, cameraOffset, cameraTransitionDuration } = cameraConfig.speedLock

    cameraManager.setTLookAtCoef(1)

    const cameraOffsetEdited = cameraOffset.clone()
    const cameraOffsetTransition = player.worldEnvLinesManager.actualIdealOffset.clone()
    gsap.to(cameraOffsetTransition, {
      duration: cameraTransitionDuration,
      x: cameraOffsetEdited.x,
      z: cameraOffsetEdited.z,
      y: cameraOffsetEdited.y,
      onUpdate: () => {

        cameraManager.changeIdeals(cameraOffsetTransition)

      },
      onComplete: () => {

        uiState().blueBoxTextType = BlueBoxTextType.drawThrow
        this.changeSpeedLockSpeed(speedLockCoefFinishLine)
        this.speedLockCameraTransformationComplete = true
        disciplinePhasesManager.phaseRunning.finishPhase()

      }
    })

    audioManager.fadeOutAudio(AudioNames.audienceClapping, 1500)
    audioManager.fadeOutAudio(AudioNames.audienceIntroNoise, 700)
    audioManager.play(AudioNames.audienceCheering)
    audioManager.changeAudioVolume(AudioNames.audienceCheering, 0)
    const fadeCheeringTween = gsap.to({}, {
      duration: 2,
      onUpdate: () => {

        audioManager.changeAudioVolume(AudioNames.audienceCheering, fadeCheeringTween.progress())

      }
    })

  }

  /**
   * Deaktivovanie spomalenia
   */
  public deactivateSpeedLock(): void {

    super.deactivateSpeedLock()
    console.warn('SPEED LOCK end')

    this.speedLockCameraTransformationComplete = false
    this.changeSpeedLockSpeed(1)

  }

  /**
   * Zmena speedLockCoef a rychlosti animacii a casu
   * @param speedLockCoef - number
   */
  private changeSpeedLockSpeed(speedLockCoef: number): void {

    console.log('SPEED LOCK COEF -> ', speedLockCoef)
    disciplinePhasesManager.phaseRunning.speedLockCoef = speedLockCoef
    timeManager.changeTimeSpeed(disciplinePhasesManager.phaseRunning.speedLockCoef)
    player.animationsManager.setSpeed(disciplinePhasesManager.phaseRunning.speedLockCoef)

  }

}

export const player = new Player('')
